import {Redirect, Route, Router, Switch} from "react-router-dom";
import {useEffect, useState} from "react";
import Header from "../components/header/Header";
import $ from 'jquery'
import history from "../utils/History";
import Nav from "../components/Nav/Nav";
import ElencoAssistentiFamiliari from "./registro/ElencoAssistentiFamiliari";
import WizardRegistro from "./registro/WizardRegistro/WizardRegistro";
import ElencoUtenti from "./utenti/ElencoUtenti";
import ElencoSportelli from "./sportelli/ElencoSportelli";
import Footer from "../components/Footer/Footer";
import Interceptor from "../services/Interceptor";
import auth from "../../src/utils/AthnAuth";
import globals from '../config/appconfig'
import authConfig from "../config/authConfig";
import Faq from "./faq/Faq";
import DoveSiamo from "./doveSiamo/DoveSiamo";
import Home from "./home/Home";
import CercaAssistentiFamiliari from "./home/CercaAssistentiFamiliari";
import Report from "./report/Report";
import {useDispatch} from "react-redux";
import {deleteAssistente, deleteStateUpload} from "../actions/IndexActions";
import Login from "./login/Login";
import Spinner from "../components/spinner/Spinner";
import SchedaAssistente from "./schedaAssistente/SchedaAssistente";
import LogoutOrNotAuthorized from "./LogoutOrNotAuthorized/LogoutOrNotAuthorized";
import LoginCallback from "./login/LoginCallback";
import SelezioneSportello from "./selezioneSportello/SelezioneSportello";
import Utils from "../utils/Utils";

auth.configurazione({
    auth: authConfig['attivazione-auth'],
    urlAthn: new URL(authConfig['url-redirect-auth']).origin,
    applicationId: "RAF",
    samlTokenErrorFunction: (code, description) => {
        let mess = "Si e verificato un problema nell'accedere ai servizi infrastrutturali (come ad esempio l'anagrafica). Contattare l'Helpdesk per sistemare la posizione fornendo il codice errore "+code+" - "+description
        // ToasterSingleton.instance().aggiuntaToaster({
        //     type: "confirm", //in caso di problemi nel recuperare il tipo di toaster, lo mostro come errore
        //     text: [mess],
        //     timestamp: Date.now()
        // });
    },
    samlTokenResources: [`${globals["app-url-backend-anagrafica"]}/anagraficheAndCandidati`]
});
function RouteRAF(props) {
    const [url, setUrl] = useState(window.location.pathname);
    const [showSpinner,setShowSpinner] = useState(false)
    const dispatch = useDispatch()
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}
    const nazioniPerCodice = JSON.parse(sessionStorage.getItem("nazioniPerCodice"))
    const provincePerCodice = JSON.parse(sessionStorage.getItem("provincePerCodice"))
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice"))
    const siglaProvincePerCodice = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    Utils.alert()
    useEffect( ()=>{
        setShowSpinner(true)
        new Interceptor()
        auth.recuperoSessione()
            .then(utente => {
                if (utente) {
                    if (!utente.gruppi) {
                        console.warn("Utente senza gruppi:", utente);
                        history.push({pathname: new URL(authConfig["url-unauthorized"]).pathname});
                        return;
                    }
                    let ok = Utils.checkStringInArray(utente.gruppi)
                    if (ok) {
                        let sessioneUtente = {
                            sessionId: "",
                            codiceFiscale: utente.codiceFiscale,
                            nome: utente.nome,
                            cognome: utente.cognome,
                            ruolo: utente.gruppi,
                            sportelli: utente.sportelli,
                            struttura: utente.codiceStruttura,
                            tipoUtente: utente.gruppi.includes("RAF-AF") ? "02" : "01",
                            loggedIn: true
                        };
                        sessionStorage.setItem("sessioneUtente",JSON.stringify(sessioneUtente))
                        auth.setSessioneUtente(sessioneUtente)
                        let jsonParam = {
                            idReport: 5
                        }
                        Utils.putReport(jsonParam)

                        if (sessioneUtente.tipoUtente === "01" || sessioneUtente.tipoUtente === "02") {
                            let jsonParam = {
                                idReport: 4,
                                ruolo: sessioneUtente.ruolo
                            }
                            Utils.putReport(jsonParam)
                        }
                        if (sessioneUtente.tipoUtente === "01") {
                            history.push({
                                pathname: "/selezioneSportello"
                            })
                        } else {
                            Utils.recuperoDatiSintesiCandidato(sessioneUtente.codiceFiscale, dispatch, history, setShowSpinner, "/profilo",comuniPerCodice,siglaProvincePerCodice,nazioniPerCodice, provincePerCodice)
                        }
                    } else {
                        let sessioneUtente = {
                            loggedIn: false,
                            tipoUtente: "03"
                        };
                        sessionStorage.setItem("sessioneUtente",JSON.stringify(sessioneUtente))
                        let path = new URL(authConfig["url-unauthorized"]).pathname;
                        history.push({pathname: path});
                    }
                    setShowSpinner(false)
                }
            }).catch((error) => {
            console.log("Not signed in");
            console.error(`Errore: ${error}`);
        });
        setShowSpinner(false)
    },[])

    useEffect(() => {
        setShowSpinner(true)
        if(url !== "/wizardRegistro" && sessioneUtente && sessioneUtente.tipoUtente === "01"){
            dispatch(deleteAssistente())
            dispatch(deleteStateUpload())
        }
        setShowSpinner(false)
    },[url])

    useEffect(() => {
        const unlisten = history.listen((location) => {
            setUrl(location.pathname);
            if (localStorage.getItem("scroll") !== "false") {
                window.scrollTo(0, 0);
            } else {
                $('html, body').animate({scrollTop: $(document).height()}, 1);
                localStorage.setItem("scroll", "true");
            }
        });
        return () => unlisten();
    }, []);

    return (
                <Router history={history}>
                    <Spinner show={showSpinner}/>
                    <Switch>
                        <Route exact path="/" render={() => (<Redirect to="/home"/>)} />
                        <Route render={() => (
                            <div>
                                <Header/>
                                {window.location.pathname === "/login" || window.location.pathname === "/selezioneSportello"?<></>:<Nav/>}
                                <Route exact path='/home' render={() => (
                                    <div><Home/></div>
                                )}/>
                                <Route exact path='/login' render={() => (
                                    <div><Login/></div>
                                )}/>
                                <Route exact path='/registro' render={() => (
                                    <div><ElencoAssistentiFamiliari/></div>
                                )}/>
                                <Route exact path='/utenti' render={() => (
                                    <div><ElencoUtenti/></div>
                                )}/>
                                <Route exact path='/sportelli' render={() => (
                                    <div><ElencoSportelli/></div>
                                )}/>
                                <Route exact path='/wizardRegistro' render={() => (
                                    <div><WizardRegistro/></div>
                                )}/>
                                <Route exact path='/profilo' render={() => (
                                    <div><WizardRegistro/></div>
                                )}/>
                                <Route exact path='/profiloAssistente' render={() => (
                                    <div><SchedaAssistente/></div>
                                )}/>
                                <Route exact path='/faq' render={() => (
                                    <div><Faq/></div>
                                )}/>
                                <Route exact path='/cercaAssistenteFamiliare' render={() => (
                                    <div><CercaAssistentiFamiliari/></div>
                                )}/>
                                <Route exact path='/doveSiamo' render={() => (
                                    <div><DoveSiamo/></div>
                                )}/>
                                <Route exact path='/report' render={() => (
                                    <div><Report/></div>
                                )}/>
                                <Route exact path='/unauthorized' render={() => (
                                    <LogoutOrNotAuthorized />
                                )}/>
                                <Route exact path='/login-callback' render={() => (
                                    <LoginCallback/>
                                )}/>
                                <Route exact path='/selezioneSportello' render={() => (
                                    <SelezioneSportello/>
                                )}/>
                                <Footer style={{position:window.location.pathname === "/unauthorized" || window.location.pathname === "/login-callback"?"fixed":"absolute",bottom:window.location.pathname === "/unauthorized"|| window.location.pathname === "/login-callback"?"0":""}}/>
                            </div>
                        )}/>
                    </Switch>
                </Router>
    );
}

export default RouteRAF;
